var _path, _path2, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 884,
    viewBox: "0 0 430 884",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430 60C430 26.8629 403.137 0 370 0L60 0C26.8629 0 0 26.8629 0 60L0 824C0 857.137 26.8629 884 60 884H370C403.137 884 430 857.137 430 824V60ZM424 60C424 30.1766 399.823 6 370 6H60C30.1766 6 6 30.1766 6 60V824C6 853.823 30.1766 878 60 878H370C399.823 878 424 853.823 424 824V60Z",
    fill: "#4C4B4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424 60C424 30.1766 399.823 6 370 6H60C30.1766 6 6 30.1766 6 60V824C6 853.823 30.1766 878 60 878H370C399.823 878 424 853.823 424 824V60ZM410 60C410 37.9086 392.091 20 370 20H60C37.9086 20 20 37.9086 20 60V824C20 846.091 37.9086 864 60 864H370C392.091 864 410 846.091 410 824V60Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 31,
    width: 124,
    height: 36,
    rx: 18,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 851,
    width: 139,
    height: 5,
    rx: 2.5,
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.8918cb1e61019463ef69a2a4fd420a46.svg";
export { ForwardRef as ReactComponent };